"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var styled_components_1 = __importStar(require("../Themes/styled-components"));

var Wrapper = styled_components_1.default('span')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), function (_a) {
  var color = _a.color;
  return color && styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      color: ", ";\n    "], ["\n      color: ", ";\n    "])), color);
});

function getColorFromProps(theme, props) {
  if (props.danger) {
    return theme.color.danger;
  } else if (props.success) {
    return theme.color.success;
  } else if (props.warning) {
    return theme.color.warning;
  } else if (props.faded) {
    return theme.color.fadedText;
  } else if (props.primary) {
    return theme.color.primary;
  }

  return 'inherit';
}

exports.getColorFromProps = getColorFromProps;

var Text =
/** @class */
function (_super) {
  __extends(Text, _super);

  function Text() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Text.prototype.render = function () {
    var _a = this.props,
        color = _a.color,
        primary = _a.primary,
        danger = _a.danger,
        success = _a.success,
        warning = _a.warning,
        faded = _a.faded,
        theme = _a.theme,
        restProps = __rest(_a, ["color", "primary", "danger", "success", "warning", "faded", "theme"]);

    var textColor = '';

    if (color) {
      textColor = color;
    } else {
      textColor = getColorFromProps(theme, this.props);
    }

    return React.createElement(Wrapper, __assign({
      color: textColor
    }, restProps), this.props.children);
  };

  Text.defaultProps = {
    className: '',
    children: null,
    primary: false,
    danger: false,
    success: false,
    warning: false,
    faded: false
  };
  return Text;
}(React.PureComponent);

exports.default = styled_components_1.withTheme(Text);
var templateObject_1, templateObject_2;